<template>
<div class="container py-5" style="min-height:600px">
   <div v-if="loading" class="d-flex flex-row justify-content-center loading_card" style="height:600px;align-items: center;">
            <div v-if="loading" class="loading_card_spinner">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3"
                    color="var(--primary-color)" />
            </div>
        </div>
  <div v-else>
 
<div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
    <!-- Repeat this card for each product -->
    <!-- يمكنك تكرار هذا العنصر مع تغيير التفاصيل حسب الحاجة -->
   <product
          v-for="(item, index) in products"
          :key="index"
          v-bind="item"
          :name="item.name"
                :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer" :unit="item.unit"
                :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount" :qnt="item.qnt"
                :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note" :range_price="item.range_price"
        />
    </div>
    <!-- بقية المنتجات ... (نفس التنسيق) -->
    <!-- يمكنك تكرار البطاقات حسب الحاجة -->
      <div class="col-lg-12 text-center">
      <nav aria-label="Page navigation example"  class="paginate_div">
        <b-pagination
          v-if="products && products.length !== 0"
          v-model="page"
          :total-rows="count"
          :per-page="paginate"
          :prev-text="$t('prev')"
          :next-text="$t('next')"
          pills
          size="sm"
  class="paginate_theme13"
            @change="handlePageChange"
        />
      </nav>
    </div>
    
  </div>
  </div>
</template>
<script>
   import product from "../components/one_product.vue";
   
   import { HalfCircleSpinner, HollowDotsSpinner } from "epic-spinners";
   
   
   export default {
     components: { product, HollowDotsSpinner, HalfCircleSpinner},
     data() {
       return {
           show_list:false,
           show_grid:true,
           DBitems: null,
         loading: false,
         loading_product: false,
         products:[],
         page: 1,
         count: 0,
         pageSize: 12,
         langChange:"",
         sort:'id',
         order:'desc',
         paginate:12,
         pagefrom:1,
         pageto:12
       };
     },
     created() {
     
   this.$store.state.showHeader = true;
        this.$store.state.showFooter = true;
       this.loading = true;
       this.loading_product = true;
       this.axios
         .post(
           this.$store.state.base_api_url + this.$store.storeName + "/theme5/products",
           
               {
               sort:  this.sort,
               order: this.order,
               paginate: this.paginate
           },
           {
             headers: {
               "Accept-Language": this.$i18n.locale,
               Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
             }
           }
           
         )
         .then((response) => {
           this.products = response.data.data;
           this.count = response.data.meta.total;
           this.pagefrom=response.data.meta.from;
           this.pageto=response.data.meta.to;
           this.loading_product = false
         })
         .then(() => (this.loading = false ));
         if(this.$i18n.locale=='ar')
         {
         document.title = this.$store.state.title_ar;
         document.getElementById("description_meta").content=this.$store.state.description_ar;
         document.getElementById("keywords_meta").content=this.$store.state.keyword_ar;
         }
         else{
           document.title = this.$store.state.title_en;
         document.getElementById("description_meta").content=this.$store.state.description_en;
         document.getElementById("keywords_meta").content=this.$store.state.keyword_en;
         }
     },
     watch: {
       langChange() {
         this.loading = true;
         this.axios
           .post(
             this.$store.state.base_api_url +
               this.$store.storeName +
               "/theme5/products?page=" +
               this.page,
               {
               sort:  this.sort,
               order: this.order,
               paginate: this.paginate
           },
             {
               headers: {
                 "Accept-Language": this.$i18n.locale,
                 Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
               }
             }
           )
           .then((response) => {
             this.products = response.data.data;
             //this.count = response.data.meta.total;
           }).then(() => {
           this.loading = false;
         });
       },
     },
     updated() {
       this.langChange=this.$i18n.locale
     },
     methods: {
       closepopup()
       {
         this.$store.state.show_product=false;
       },
    retrieveTutorials() {
  this.loading_product = true;
  this.axios
    .post(
      this.$store.state.base_api_url +
        this.$store.storeName +
        "/theme5/products",
      {
        sort:  this.sort,
        order: this.order,
        paginate: this.paginate,
        page: this.page   // ✅ أضف الصفحة هنا
      },
      {
        headers: {
          "Accept-Language": this.$i18n.locale,
          Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
        }
      }
    )
    .then((response) => {
      this.products = response.data.data;
      this.pagefrom = response.data.meta.from;
      this.pageto = response.data.meta.to;
    })
    .then(() => (this.loading_product = false));
},

       handlePageChange(value) {
         this.page = value;
         this.retrieveTutorials();
       },
   
       upadatesort(event)
     {
       this.order = event.target.value.split("/")[0]; //asc
         this.sort = event.target.value.split("/")[1]; //id
   
         this.filter_product();
     },
     filter_product()
       {
           console.log('brands array  ',this.brands_array);
   
   
           this.axios
           .post(
             this.$store.state.base_api_url +
               this.$store.storeName +
               "/theme5/products",
               {
               sort:  this.sort,
               order: this.order,
               paginate: this.paginate
           },
             {
               headers: {
                 "Accept-Language": this.$i18n.locale,
                 Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
               }
             }
           )
           .then((response) => {
             this.products = response.data.data;
             //this.count = response.data.meta.total;
           }).then(() => {
           this.loading = false;
         });
       },
   
     updatepaginate(event)
     {
       this.paginate = event.target.value
   
         this.filter_product();
     },
     
           
     },
   };
   </script>